export default __webpack_public_path__ + "static/media/0071.bb03fc02.jpg";